import { lazy, Suspense, useContext } from "react";
import { appDataContext } from "@/context";
import { Helmet } from "react-helmet-async";
import { useLangStore } from "@/store/lang-store";
import StaticPageLayout from "@/layouts/StaticPageLayout";
import Article from "@/components/Article";
// Change to static import to fix build warning and improve LCP
import SearchBanner from "@/components/SearchBanner";

const BlogSection = lazy(() => import("@/components/BlogSection"));
// const SearchBanner = lazy(() => import("@/components/SearchBanner"));

const GroupPurchasePage = () => {
  const dataContext = useContext(appDataContext);
  const text = dataContext.lang;
  const routeMap = dataContext?.routeMap;
  const { langStore } = useLangStore();
  const properties = dataContext.properties;
  return (
    <>
      <StaticPageLayout>
        <Helmet>
          <title>{` ${text?.groupPurchase.title} - ${text?.site.title}`}</title>
        </Helmet>
        <header>
          <h1>{text?.groupPurchase.title}</h1>
        </header>
        <Article
          className="article"
          lang={langStore}
          url={properties?.groupPurchase.articles.url1}
          hideImage={true}
          hideTitle={true}
        />
        {/* Removed Suspense as SearchBanner is now static */}
        <SearchBanner
          lang={text}
          isHome
          title={text?.grouppurchasePage.searchTitle}
        />
      </StaticPageLayout>
      <Suspense fallback={<div style={{height: "100px"}}></div>}>
        <BlogSection length="4" text={text} routeMap={routeMap} />
      </Suspense>
    </>
  );
};

export default GroupPurchasePage;
